import axios from "axios";

export const Http = axios.create({
    timeout: 5000,
    headers: { Accept: "application/json" },
});
